import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { describeBundleRelevanceStatus } from "./bundleRelevanceStatusPresentation";
import type { BundleRelevanceStatus } from "./useBundleRelevanceStatusesForEncounter";

interface RelevanceStatusBadgeProps {
  status: BundleRelevanceStatus;
}

export function RelevanceStatusBadge({ status }: RelevanceStatusBadgeProps) {
  const { label, icon: Icon, tooltip, colorClass } = describeBundleRelevanceStatus(status);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className={cn("shrink-0 rounded-full border-transparent p-1", colorClass)}
            aria-label={label}
          >
            <Icon className="h-3 w-3" aria-hidden="true" />
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
